import Vuex from 'vuex';
import Vue from 'vue';
import auth from './modules/auth'

// Tell Vue to use Vuex
// initial handshake between VUE and VUEX
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth
    }
});